<template lang="pug">
  .wrapper(:class="{ 'is-vertical': isMobile }")
    MintBackground(
      :is-mobile="isMobile"
      :show-sale-info-bar="showSaleInfoBar"
      @video-ready="isVideoReady = true"
    )

    template(v-if="isForceEnded")
      MintForceEnded
    template(v-else-if="isForcePaused")
      MintForcePaused
    template(v-else-if="noSaleStarted")
      MintComingSoon(:is-mobile="isMobile")
    template(v-else-if="!isUserConnected")
      MintNotConnected(:is-mobile="isMobile")
    template(v-else-if="isMintSuccessful || (isPreSaleLive && getAccountData.hasPopulated && getAccountData.isWhitelisted > 0 && getAccountData.allowedMintQuantity === getAccountData.mintedQuantity) || (getIOContractData.isPublicSaleLive && getAccountData.hasPopulated && getAccountData.hasMintedDA)")
      MintSuccess
    template(v-else-if="hasIOContractPopulated && !getIOContractData.remainingSupply")
      MintSoldOut
    template(v-else-if="hasIOContractPopulated && !noSaleStarted")
      MintSale(
        @mint-success="mintSuccess"
      )
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import MintBackground from '@/components/MintBackground';
import MintNotConnected from '@/components/MintNotConnected';
import MintSuccess from '@/components/MintSuccess';
import MintComingSoon from '@/components/MintComingSoon';
import MintSoldOut from '@/components/MintSoldOut';
import MintSale from '@/components/MintSale';
import MintForcePaused from '@/components/MintForcePaused';
import MintForceEnded from '@/components/MintForceEnded';

import saleMixin from '@/mixins/sale-mixins';

export default {
  name: 'MintPage',
  components: {
    MintBackground,
    MintNotConnected,
    MintSuccess,
    MintComingSoon,
    MintSoldOut,
    MintSale,
    MintForcePaused,
    MintForceEnded,
  },
  mixins: [saleMixin],
  data() {
    return {
      isVideoReady: false,
      isMintSuccessful: false,
    };
  },
  props: {
    isMobile: { type: Boolean, default: false },
    showSaleInfoBar: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('accounts', ['isUserConnected', 'getAccountData', 'getActiveAccountChecksum']),
    ...mapGetters('contracts', ['getIOContractData']),
    isPageReady() {
      return this.isVideoReady;
    },
    hasIOContractPopulated() {
      return this.getIOContractData.hasPopulated;
    },
    hasAccountPopulated() {
      return this.getAccountData.hasPopulated;
    },
    isForcePaused() {
      return process.env.VUE_APP_FORCE_PAUSE === 'true';
    },
    isForceEnded() {
      return process.env.VUE_APP_FORCE_END === 'true';
    },
  },
  watch: {
    isPageReady(isReady) {
      if (isReady) this.hideLoadingPage();
    },
    async getActiveAccountChecksum() {
      this.isMintSuccessful = false;
    },
  },
  methods: {
    ...mapMutations(['hideLoadingPage']),
    mintSuccess() {
      this.isMintSuccessful = true;
      this.$emit('mint-success');
    },
  },
};
</script>

<style lang="scss">
.wrapper {
  height: 100%;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &.is-vertical {
    justify-content: center;
    text-align: center;

    .coming-soon__container,
    .sold-out__container,
    .mint-success__container,
    .sale__container,
    .not-connected__container {
      max-width: none;
    }

    h1[class*='__title'] {
      font-size: 2.25rem;
    }
  }
}

.coming-soon__container,
.sold-out__container,
.mint-success__container,
.sale__container,
.not-connected__container,
.paused__container,
.ended__container {
  max-width: 58%;
  margin-right: 0;
  color: $white;
  margin-top: -50px;
}

.not-connected__logo,
.coming-soon__logo {
  display: block;
  margin: 0 auto;
  margin-bottom: 10px;
  width: 70%;

  svg {
    width: 100%;
    height: auto;
    display: block;

    path,
    ellipse {
      fill: $white;
    }

    circle {
      stroke: $white;
    }
  }
}
</style>
